const isObject = (value: unknown): value is Record<string, unknown> => !!value && typeof value === "object";

export const getError = (error: any): string => error ? error.error?.code || error.error?.response?.code || error.error?.response?.errorType || error.error?.error?.message || error.error?.message || "GENERAL_ERROR" : error;

/**
 * Every field of the error body (and of its nested `response`), so translations can use any
 * value the API sends with the error (e.g. `{{pendingPoints}}`, `{{daysUntilRedeemable}}`).
 */
export const getErrorParams = (error: any): Record<string, unknown> => {
  const body: unknown = error?.error;
  if (!isObject(body)) return {};

  return { ...body, ...(isObject(body["response"]) ? body["response"] : {}) };
};
